// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ITriggerThresholdDto } from './ITriggerThresholdDto';
import {
    ITriggerThresholdDtoFromJSON,
    ITriggerThresholdDtoFromJSONTyped,
    ITriggerThresholdDtoToJSON,
    ITriggerThresholdDtoToJSONTyped,
} from './ITriggerThresholdDto';

/**
 * 
 * @export
 * @interface IProcessingTierLiteDto
 */
export interface IProcessingTierLiteDto {
    /**
     * 
     * @type {number}
     * @memberof IProcessingTierLiteDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IProcessingTierLiteDto
     */
    name?: string;
    /**
     * 
     * @type {Array<ITriggerThresholdDto>}
     * @memberof IProcessingTierLiteDto
     */
    triggers?: Array<ITriggerThresholdDto>;
    /**
     * 
     * @type {number}
     * @memberof IProcessingTierLiteDto
     */
    next_tier_id?: number;
    /**
     * 
     * @type {Date}
     * @memberof IProcessingTierLiteDto
     */
    valid_from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IProcessingTierLiteDto
     */
    valid_to?: Date;
}

/**
 * Check if a given object implements the IProcessingTierLiteDto interface.
 */
export function instanceOfIProcessingTierLiteDto(value: object): value is IProcessingTierLiteDto {
    return true;
}

export function IProcessingTierLiteDtoFromJSON(json: any): IProcessingTierLiteDto {
    return IProcessingTierLiteDtoFromJSONTyped(json, false);
}

export function IProcessingTierLiteDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IProcessingTierLiteDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'triggers': json['triggers'] == null ? undefined : ((json['triggers'] as Array<any>).map(ITriggerThresholdDtoFromJSON)),
        'next_tier_id': json['next_tier_id'] == null ? undefined : json['next_tier_id'],
        'valid_from': json['valid_from'] == null ? undefined : (new Date(json['valid_from'])),
        'valid_to': json['valid_to'] == null ? undefined : (new Date(json['valid_to'])),
    };
}

export function IProcessingTierLiteDtoToJSON(json: any): IProcessingTierLiteDto {
    return IProcessingTierLiteDtoToJSONTyped(json, false);
}

export function IProcessingTierLiteDtoToJSONTyped(value?: IProcessingTierLiteDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'triggers': value['triggers'] == null ? undefined : ((value['triggers'] as Array<any>).map(ITriggerThresholdDtoToJSON)),
        'next_tier_id': value['next_tier_id'],
        'valid_from': value['valid_from'] == null ? undefined : ((value['valid_from']).toISOString().substring(0,10)),
        'valid_to': value['valid_to'] == null ? undefined : ((value['valid_to']).toISOString().substring(0,10)),
    };
}

